module.exports = __webpack_public_path__ + "img/appointment.00dc2526.svg";